module.exports = __webpack_public_path__ + "img/trash-alt-solid.91def728.svg";